import { refreshPasswordManagerToken } from "./refreshPasswordManagerToken";

type Dispatch = (action: unknown) => { unwrap: () => Promise<unknown> };

export const handlePasswordManagerUnauthorized = async (_params: unknown, _state: unknown, dispatch: Dispatch) => {
	await dispatch(refreshPasswordManagerToken()).unwrap();
};
